(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-index"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  const clamp = value => Math.max(0, Math.min(1, value));

  function createJar(canvas, frames) {
    const context = canvas.getContext('2d', { alpha: true });
    if (!context) return null;
    let dead = false;
    let width = 1;
    let height = 1;
    const images = frames.map(() => new Image());
    const loaded = Promise.all(frames.map((frame, index) => new Promise((resolve, reject) => {
      const image = images[index];
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => image.decode().then(resolve, reject);
      image.onerror = reject;
      image.src = frame.src;
    })));

    function resize() {
      const rect = canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      width = Math.max(1, Math.round(rect.width * ratio));
      height = Math.max(1, Math.round(rect.height * ratio));
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
      }
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
    }

    function draw(progress) {
      if (dead) return;
      const phase = clamp(progress) * frames.length;
      const whole = Math.floor(phase);
      const first = whole % frames.length;
      const next = (first + 1) % frames.length;
      const blend = phase - whole;
      const targetHeight = height * .93;
      const targetWidth = targetHeight * .55;
      const x = (width - targetWidth) / 2;
      const y = (height - targetHeight) / 2;
      context.clearRect(0, 0, width, height);

      function paint(index, opacity, mode) {
        if (opacity <= 0) return;
        const image = images[index];
        const bounds = frames[index].bounds;
        context.globalAlpha = opacity;
        context.globalCompositeOperation = mode;
        context.drawImage(image,
          bounds[0] * image.naturalWidth, bounds[1] * image.naturalHeight,
          (bounds[2] - bounds[0]) * image.naturalWidth,
          (bounds[3] - bounds[1]) * image.naturalHeight,
          x, y, targetWidth, targetHeight);
      }

      paint(first, 1 - blend, 'source-over');
      paint(next, blend, 'lighter');
      context.globalAlpha = 1;
      context.globalCompositeOperation = 'source-over';
      canvas.dataset.angle = (progress * Math.PI * 2).toFixed(6);
      canvas.dataset.frame = String(first);
      canvas.dataset.blend = blend.toFixed(6);
    }

    return { loaded, resize, draw, destroy() {
      dead = true;
      context.clearRect(0, 0, width, height);
    } };
  }

  function initialize(root) {
    if (instances.has(root)) return;
    const visual = root.querySelector('[data-cb-jar]');
    const canvas = visual.querySelector('canvas');
    const frames = JSON.parse(visual.querySelector('[data-cb-turntable]').textContent);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let jar = null;
    let frame = 0;
    let observer = null;
    let destroyed = false;
    let ready = false;
    let currentProgress = null;
    let targetProgress = 0;
    let lastTime = 0;
    let geometryDirty = true;
    let sizeDirty = true;

    function update(time) {
      frame = 0;
      if (!jar || !ready || reduced.matches || document.hidden || destroyed) {
        lastTime = 0;
        return;
      }
      if (geometryDirty) {
        const rect = root.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) {
          lastTime = 0;
          return;
        }
        const distance = innerWidth < 750
          ? Math.max(1, rect.height * .6)
          : Math.max(1, rect.height - innerHeight + 72);
        targetProgress = clamp((72 - rect.top) / distance);
        geometryDirty = false;
      }
      if (sizeDirty) {
        jar.resize();
        sizeDirty = false;
      }
      const elapsed = lastTime ? Math.min(64, Math.max(0, time - lastTime)) : 1000 / 60;
      lastTime = time;
      if (currentProgress === null) currentProgress = targetProgress;
      currentProgress += (targetProgress - currentProgress) * -Math.expm1(-elapsed / 100);
      const settled = Math.abs(targetProgress - currentProgress) < .00001;
      if (settled) currentProgress = targetProgress;
      jar.draw(currentProgress);
      root.dataset.rotation = currentProgress.toFixed(6);
      visual.setAttribute('data-ready', '');
      if (!settled) frame = requestAnimationFrame(update);
      else lastTime = 0;
    }

    function schedule() {
      if (!frame && !destroyed) frame = requestAnimationFrame(update);
    }

    function onScroll() {
      geometryDirty = true;
      schedule();
    }

    function onResize() {
      geometryDirty = true;
      sizeDirty = true;
      schedule();
    }

    function start() {
      if (jar || reduced.matches || destroyed) return;
      const candidate = createJar(canvas, frames);
      if (!candidate) return;
      jar = candidate;
      candidate.loaded.then(() => {
        if (destroyed || reduced.matches || jar !== candidate) return;
        ready = true;
        geometryDirty = true;
        sizeDirty = true;
        schedule();
      }).catch(() => {
        if (jar !== candidate) return;
        visual.removeAttribute('data-ready');
        candidate.destroy();
        jar = null;
        ready = false;
      });
    }

    function motionChange() {
      if (reduced.matches) {
        cancelAnimationFrame(frame);
        frame = 0;
        lastTime = 0;
        currentProgress = null;
        ready = false;
        visual.removeAttribute('data-ready');
        jar?.destroy();
        jar = null;
      } else {
        start();
        onResize();
      }
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          start();
          onScroll();
        } else {
          cancelAnimationFrame(frame);
          frame = 0;
          lastTime = 0;
        }
      }, { rootMargin: '250px' });
      observer.observe(root);
    } else start();

    const resize = new ResizeObserver(onResize);
    resize.observe(root);
    resize.observe(visual);
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onResize, { passive: true });
    document.addEventListener('visibilitychange', onScroll);
    reduced.addEventListener('change', motionChange);
    instances.set(root, () => {
      destroyed = true;
      observer?.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      removeEventListener('scroll', onScroll);
      removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onScroll);
      reduced.removeEventListener('change', motionChange);
      jar?.destroy();
      instances.delete(root);
    });
  }

  document.querySelectorAll('[data-cb-diet-scene]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cb-diet-scene]').forEach(initialize));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-cb-diet-scene]').forEach(root => instances.get(root)?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
